// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/@nackle/paper/dist/index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  height: 100vh;
  overflow-x: hidden;
}
#app-root {
  height: 100%;
}
.nkl-layout-content.app-content {
  flex-shrink: 0;
  height: 100%;
  overflow-x: hidden;
}
.root-layout {
  height: 100%;
}
.nkl-layout-sider-children {
  overflow: auto;
}
.nkl-layout-content.page-content {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.nkl-layout-header.page-header {
  background: transparent;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: 80px;
}
.nkl-layout-header.page-header > .nkl-row {
  width: 100%;
}
.nkl-layout-content.page-content {
  flex-shrink: 0;
}
.nkl-layout-content.app-content {
  flex-shrink: 0;
}
.breadcrumbs {
  margin-bottom: 1rem;
  background: #f5f5f5;
  padding: 0.5rem;
}
.breadcrumbs a,
.breadcrumbs span {
  position: relative;
  display: inline-block;
  margin-right: 1rem;
}
.breadcrumbs a:after,
.breadcrumbs span:after {
  border-style: solid;
  border-width: 0.125em 0.125em 0 0;
  content: '';
  display: inline-block;
  height: 0.45em;
  left: 0.5em;
  position: relative;
  top: 0.55em;
  transform: rotate(45deg);
  vertical-align: top;
  width: 0.45em;
}
.breadcrumbs a:last-child:after,
.breadcrumbs span:last-child:after {
  content: none;
}
.content-container:has(.v2) {
  padding: 2rem;
}
.v2 .pager {
  padding: 1rem 0rem;
  display: flex;
  align-items: center;
}
.v2 .pager > div {
  display: flex;
  flex: 1;
  justify-content: center;
  flex-wrap: wrap;
}
.v2 .pager .page {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  margin: 1rem 0.5rem;
}
.v2 .pager .page.active {
  color: blue;
  text-decoration: underline;
  font-weight: bold;
}
.v2 .pager .left-arrow,
.v2 .pager .right-arrow {
  font-weight: bold;
  cursor: pointer;
  margin: 1rem 0.5rem;
  flex: 0;
}
.v2 .pager .left-arrow svg,
.v2 .pager .right-arrow svg {
  width: 0.9375rem;
  height: 0.9375rem;
}
.v2 .pager .left-arrow.disabled .cpd-icon,
.v2 .pager .right-arrow.disabled .cpd-icon {
  fill: lightgrey;
}
.v2 .add-group .company-select,
.v2 .add-group .member-select {
  min-width: auto;
  width: auto;
}
.v2 fieldset,
.v2 .fieldset {
  border: none;
  background-color: lightgrey;
  margin-bottom: 10px;
  border-radius: 4px;
  width: 100%;
  max-width: 100%;
  padding: 1rem;
}
.v2 h2,
.v2 .h2 {
  max-width: 100%;
}
.v2 .button-group button {
  display: inline-block;
  margin-right: 1rem;
}
.v2 .button-group .button-cancel {
  color: #000000;
  background-color: #ffffff;
}
.v2 .bp3-button-group {
  height: 100%;
}
.v2 .bp3-button.policy,
.v2 .bp3-button.role,
.v2 .bp3-button.save,
.v2 .bp3-button.allow-deny-btn,
.v2 .bp3-button.add-date,
.v2 .bp3-button.caret-btn,
.v2 .bp3-button.add-button {
  background-color: #001529;
  color: white;
  background-image: none;
  box-shadow: none;
  border-radius: 0;
  height: 100%;
}
.v2 .bp3-button.policy svg,
.v2 .bp3-button.role svg,
.v2 .bp3-button.save svg,
.v2 .bp3-button.allow-deny-btn svg,
.v2 .bp3-button.add-date svg,
.v2 .bp3-button.caret-btn svg,
.v2 .bp3-button.add-button svg {
  fill: white;
}
.v2 .bp3-button.policy:hover,
.v2 .bp3-button.role:hover,
.v2 .bp3-button.save:hover,
.v2 .bp3-button.allow-deny-btn:hover,
.v2 .bp3-button.add-date:hover,
.v2 .bp3-button.caret-btn:hover,
.v2 .bp3-button.add-button:hover {
  background-color: #063057;
  box-shadow: 0px 3px 12px 2px rgba(0, 0, 0, 0.3);
}
.v2 .bp3-button.policy:active,
.v2 .bp3-button.role:active,
.v2 .bp3-button.save:active,
.v2 .bp3-button.allow-deny-btn:active,
.v2 .bp3-button.add-date:active,
.v2 .bp3-button.caret-btn:active,
.v2 .bp3-button.add-button:active {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
}
.v2 .bp3-button.policy:focus,
.v2 .bp3-button.role:focus,
.v2 .bp3-button.save:focus,
.v2 .bp3-button.allow-deny-btn:focus,
.v2 .bp3-button.add-date:focus,
.v2 .bp3-button.caret-btn:focus,
.v2 .bp3-button.add-button:focus {
  outline: none;
}
.v2 .group-edit-form,
.v2 .group-add-form {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 5rem;
}
.v2 .group-edit-form .back-link,
.v2 .group-add-form .back-link {
  margin-top: 2rem;
}
.v2 .group-edit-form .error-container,
.v2 .group-add-form .error-container {
  position: relative;
  color: #ff0000;
}
.v2 input,
.v2 select {
  background-color: #ffffff;
  border-radius: 5px;
  border: 1px solid #DFE1E6;
  box-shadow: none;
  box-sizing: border-box;
  color: #172B4D;
  font-family: inherit;
  font-size: 14px;
  line-height: 20px;
  max-width: 100%;
  outline: none;
  padding: 0.5rem;
  min-width: 9rem;
}
.v2 .control-label {
  font-size: 12px;
}
.v2 table {
  border: solid #999;
  border-width: 1px 0 0 1px;
  border-collapse: collapse;
}
.v2 table td,
.v2 table th {
  border: solid #999;
  border-width: 0 1px 1px 0;
  padding: 1rem;
}
.v2 .app-name-header {
  background: #ccc;
  padding: 0.5rem;
  font-weight: bold;
  font-size: 1.25rem;
}
.v2 .member-select {
  min-width: 95%;
  width: 20rem;
}
.v2 .main > div {
  padding: 1rem;
}
.v2 dt {
  font-size: 1rem;
  font-weight: bold;
  border-top: 1px solid #999;
  padding: 0.25rem;
  margin: 0.25rem;
}
.v2 dd {
  padding: 0.25rem;
  line-height: 1.3;
}
.v2 summary {
  cursor: pointer;
}
.v2 summary:hover {
  text-decoration: underline;
}
.v2 .Select .Select-control {
  height: 2.375rem;
}
.v2 .Select .Select-control .Select-multi-value-wrapper .Select-placeholder {
  line-height: 2.375rem;
}
.v2 .Select .Select-control .Select-multi-value-wrapper .Select-value {
  background-color: #fed8cd;
  border-radius: 2px;
  border: 1px solid #fdb29b;
  color: #FB5D2D;
  display: inline-block;
  font-size: 0.9em;
  line-height: 1.4;
  margin-left: 5px;
  margin-top: 5px;
  vertical-align: top;
}
.v2 table.bp3-html-table tbody tr:first-child td {
  box-shadow: none;
}
.v2 .side-col {
  padding-left: 0;
  padding-right: 0;
}
.v2 .side-col .sidebar {
  background: #333;
}
.v2 .side-col .sidebar .links {
  padding-top: 3.5rem;
}
.v2 .side-col .sidebar .bp3-dark {
  background: #333;
}
.v2 .side-col .sidebar .bp3-dark .bp3-tab {
  padding-left: 3rem;
}
.v2 .bp3-tab-list {
  width: 100%;
}
.v2 .container {
  min-height: calc(100vh - 7.25rem);
}
.v2 .deny {
  font-style: italic;
  font-weight: normal;
}
.v2 .wildcard-strong {
  font-weight: bold;
}
.v2 .wildcard-permission {
  margin-left: 1rem;
}
.v2 .bp3-dark .bp3-tab-indicator {
  background-color: rgba(251, 93, 45, 0.5) !important;
}
.v2 .bp3-dark .bp3-tab[aria-selected="true"] {
  color: #f2f2f2;
}
.v2 .bp3-dark .bp3-tab[aria-selected="true"]:hover {
  color: #ff8a66;
}
.v2 .bp3-dark .bp3-tab:not([aria-disabled="true"]):hover {
  color: #ff8a66;
}
.v2 .bp3-dark .bp3-tab:focus {
  outline: rgba(251, 93, 45, 0.6) auto 2px;
}
.v2 .permissions-count {
  cursor: pointer;
  text-decoration: underline;
}
.v2 .popover-permissions .bp3-popover-content {
  padding: 0.5rem 1rem;
}
.v2 .nkl-layout-header.app-header {
  display: flex;
  align-items: center;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  z-index: 1001;
  padding: 0 24px;
  justify-content: space-between;
}
.v2 .header-logo img {
  height: 40px;
}
.v2 .app-header {
  color: white;
}
.v2 .app-header h2 {
  color: white;
}
.v2 .app-header .user-info {
  line-height: 32px;
  display: flex;
  flex-direction: column;
}
.v2 .app-header .user-info a {
  color: white;
  height: 32px;
}
.v2 .app-header .user-info span {
  height: 32px;
}
.v2 .app-content .sub-header .nkl-menu-horizontal {
  background: #666;
  color: white;
}
.v2 .app-content .sub-header .nkl-menu-horizontal .nkl-menu-item-selected {
  background: #f0f2f5;
  border: 0;
  font-weight: bold;
}
.v2 .app-content .sub-header .nkl-menu-horizontal .nkl-menu-item {
  padding-left: 20px;
  padding-right: 20px;
  margin-left: 0;
  margin-right: 0;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
